// analytics constants
export const SOURCE_NAME = 'screenDirectory';
export const ADD_SCREEN = 'addScreen';
export const SCREENS_TABLE = 'screensTable';
export const SCREEN_STRING = 'screen';
export const SCREEN_NAME = 'screenName';
export const SCREEN_SCHEMES = 'screenSchemes';
export const SCREEN_SCHEME = 'screenScheme';
export const WORKFLOW = 'workflow';
export const SORT_ORDER = 'sortOrder';
export const SCREENS_COLUMN = 'screensColumn';
export const PAGE = 'page';
export const SCREEN_ACTIONS = 'screenActions';
export const ORDER = Object.freeze({
	ASC: 'asc',
	DESC: 'desc',
});
export const CURRENT_PAGE = 'currentPage';
export const MAXIMUM_PAGE = 'maximumPage';

// test id constants
export const ADD_SCREEN_PAGE_BUTTON = 'admin-pages-screens-page.ui.add-screen-button';
export const SCREEN_PAGE_HELP_BUTTON = 'admin-pages-screens-page.ui.add-screen-help-button';
